// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader@7.1.2_@rspack+core@1.3.4_@swc+helpers@0.5.5__webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader@7.1.2_@rspack+core@1.3.4_@swc+helpers@0.5.5__webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Filepicker CSS */
.filepicker {
    font-family: sans-serif;
}

div.filepicker {
    text-align: center;
    padding: 5px;
    background-color: #E1E1E1;
    border-radius: 5px;
    min-height: 60px;
    border: 2px dashed #C7C7C7;
}

/* Icon */
.filepicker-file-icon
{
    position: relative;

    display: inline-block;

    margin: 1.5em 0 2.5em 0;
    padding-left: 45px;

    color: black;
}
.filepicker-file-icon::before
{
    position: absolute;
    top: -7px;
    left: 0;

    width: 29px;
    height: 34px;

    content: '';

    border: solid 2px #7F7F7F;
    border-radius: 2px;
}
.filepicker-file-icon::after
{
    font-size: 11px;
    line-height: 1.3;

    position: absolute;
    top: 9px;
    left: -4px;

    padding: 0 2px;

    content: 'file';
    content: attr(data-filetype);
    text-align: right;
    letter-spacing: 1px;
    text-transform: uppercase;

    color: #fff;
    background-color: #000;
}
.filepicker-file-icon .fileCorner
{
    position: absolute;
    top: -7px;
    left: 22px;

    width: 0;
    height: 0;

    border-width: 11px 0 0 11px;
    border-style: solid;
    border-color: white transparent transparent #920035;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/.pnpm/react-dropzone-component@3.2.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-dropzone-component/styles/filepicker.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,SAAS;AACT;;IAEI,kBAAkB;;IAElB,qBAAqB;;IAErB,uBAAuB;IACvB,kBAAkB;;IAElB,YAAY;AAChB;AACA;;IAEI,kBAAkB;IAClB,SAAS;IACT,OAAO;;IAEP,WAAW;IACX,YAAY;;IAEZ,WAAW;;IAEX,yBAAyB;IACzB,kBAAkB;AACtB;AACA;;IAEI,eAAe;IACf,gBAAgB;;IAEhB,kBAAkB;IAClB,QAAQ;IACR,UAAU;;IAEV,cAAc;;IAEd,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;;IAEzB,WAAW;IACX,sBAAsB;AAC1B;AACA;;IAEI,kBAAkB;IAClB,SAAS;IACT,UAAU;;IAEV,QAAQ;IACR,SAAS;;IAET,2BAA2B;IAC3B,mBAAmB;IACnB,mDAAmD;AACvD","sourcesContent":["/* Filepicker CSS */\n.filepicker {\n    font-family: sans-serif;\n}\n\ndiv.filepicker {\n    text-align: center;\n    padding: 5px;\n    background-color: #E1E1E1;\n    border-radius: 5px;\n    min-height: 60px;\n    border: 2px dashed #C7C7C7;\n}\n\n/* Icon */\n.filepicker-file-icon\n{\n    position: relative;\n\n    display: inline-block;\n\n    margin: 1.5em 0 2.5em 0;\n    padding-left: 45px;\n\n    color: black;\n}\n.filepicker-file-icon::before\n{\n    position: absolute;\n    top: -7px;\n    left: 0;\n\n    width: 29px;\n    height: 34px;\n\n    content: '';\n\n    border: solid 2px #7F7F7F;\n    border-radius: 2px;\n}\n.filepicker-file-icon::after\n{\n    font-size: 11px;\n    line-height: 1.3;\n\n    position: absolute;\n    top: 9px;\n    left: -4px;\n\n    padding: 0 2px;\n\n    content: 'file';\n    content: attr(data-filetype);\n    text-align: right;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n\n    color: #fff;\n    background-color: #000;\n}\n.filepicker-file-icon .fileCorner\n{\n    position: absolute;\n    top: -7px;\n    left: 22px;\n\n    width: 0;\n    height: 0;\n\n    border-width: 11px 0 0 11px;\n    border-style: solid;\n    border-color: white transparent transparent #920035;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
